import Controller from "./countries.controller";
import template from "./countries.html";

const countries = {
  template,
  controller: Controller,
};

export default countries;



// WEBPACK FOOTER //
// ./src/pages/countries/countries.component.js